<template>
  <div>
    <div class="page-header bg-4" data-parallax="true">
      <b-container>
        <b-row align-h="center">
          <b-col class="text-center">
            <b-img width="200" src="/assets/img/Velios- icon-red.png" />
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col class="text-center" style="margin-top:12px">
            <b-img width="400" src="/assets/img/Velios-logotype-red.png" />
            <!-- <h1><span class="text-primary">Ride</span> Velios</h1>
            <h4>Turn your training into gaming.</h4>
            <b-button variant="primary" @click="readMore()">Read more</b-button> -->
          </b-col>
        </b-row>

        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h3 class="text-center" style="margin-top:60px;margin-bottom:0">GET THE BETA</h3>
            <!-- Begin Mailchimp Signup Form -->
            <!-- <link href="//cdn-images.mailchimp.com/embedcode/slim-10_7.css" rel="stylesheet" type="text/css"> -->
            <div id="mc_embed_signup">
              <form
                action="https://foodforbenjamin.us2.list-manage.com/subscribe/post?u=5289a1a9fed16dcb21c7b39b1&amp;id=1278063ffc"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate contact-form"
                style="margin-top:0"
                target="_blank"
                novalidate
              >
                <b-row align-h="center">
                  <b-col md="6">
                    <input
                      type="email"
                      value=""
                      name="EMAIL"
                      class="form-control"
                      style="color:white"
                      id="mce-EMAIL"
                      placeholder="Your email address"
                      required
                    />
                  </b-col>
                </b-row>
                <b-row align-h="center">
                  <b-col class="text-center">
                    <input
                      type="submit"
                      value="GO"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="btn btn-primary btn-raised"
                    />
                  </b-col>
                </b-row>
                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div
                  style="position: absolute; left: -5000px"
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="b_5289a1a9fed16dcb21c7b39b1_1278063ffc"
                    tabindex="-1"
                    value=""
                  />
                </div>
              </form>
            </div>
            <!--End mc_embed_signup-->
          </div>
        </div>
      </b-container>
    </div>
    <div
      ref="mainContent"
      class="main main-raised"
      style="padding-bottom: 48px; margin-bottom: 96px;"
    >
      <b-container>
        <b-row align-h="center" style="padding-top: 48px">
          <b-col md="8" class="text-center">
            <h1>Indoor cycling is evolving</h1>
            <h3>
              Immerse yourself in a virtual world where you are powered by your
              legs but manoeuvred by your game controller. Where you ride a bike
              but control a hover ship chased by enemy drones.
            </h3>
            <h1>
              <i class="material-icons">directions_bike</i> +
              <i class="material-icons">sports_esports</i>
            </h1>
            <h4>
              Velios takes indoor cycling to an entirely new level. Combining
              gaming and training to bring you a totally immersive workout
              experience.
            </h4>
            <h4>
              Compete against yourself, your friends and the rest of the world
              across multiple levels of high-intensity challenges that will test
              both your fitness and your gaming skills.
            </h4>
          </b-col>
        </b-row>

        <b-row align-h="center" style="padding-top: 48px">
          <b-col md="8" class="text-center">
            <h2>Get an Inside Look</h2>
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col lg="6">
            <b-card class="bg-col-dark-blue text-white" img-src="assets/img/beta.jpg" @click="open('https://www.youtube.com/watch?v=1OZHCfAyQ20')">
              <b-card-text>
                <b-row align-v="center">
                  <b-col cols="2" sm="2" style="text-align:right"><i class="material-icons big-icon emphasis">play_circle</i></b-col>
                  <b-col cols="10" sm="10"><h3>Beta Teaser</h3></b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card class="bg-col-dark-blue text-white" img-src="assets/img/road.jpg" @click="open('https://www.youtube.com/watch?v=5BPozHhP6EU')">
              <b-card-text>
                <b-row align-v="center">
                  <b-col cols="2" style="text-align:right"><i class="material-icons big-icon emphasis">play_circle</i></b-col>
                  <b-col cols="10"><h3>Playtest: The King's Road</h3></b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <!-- <b-row style="padding: 48px 0 0 0;">
          <b-col class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              src="https://www.youtube.com/embed/1OZHCfAyQ20"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </b-col>
        </b-row> -->

        <b-row align-h="center" style="padding-top: 0px">
          <b-col md="6">
            <div class="info info-horizontal">
              <div class="icon icon-rose">
                <i class="material-icons">local_fire_department</i>
              </div>
              <div class="description">
                <h3 class="info-title">How it works</h3>
                <p>
                  Connect your smart trainer or power meter to your computer -
                  along with a game controller. As you pedal, Velios uses your
                  power output to charge up your ship, allowing you to propel
                  yourself through the virtual world, manoeuvred by your game
                  controller.
                </p>
              </div>
            </div>
          </b-col>
          <b-col md="6">
            <div class="info info-horizontal">
              <div class="icon icon-rose">
                <i class="material-icons">computer</i>
              </div>
              <div class="description">
                <h3 class="info-title">What you need</h3>
                <p>
                  You’ll need a compatible Bluetooth or ANT
                  <strong>smart trainer or power meter</strong>; a compatible
                  <strong>game controller</strong> (USB, PS4 or Xbox); and a
                  <strong>PC or Mac</strong> (Windows 10+ or OSX Catalina+). And
                  a bike obviously.
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row style="margin:48px 0">
          <b-col class="text-center">
            <b-button @click="gotoTop" title="GET THE BETA" size="lg" variant="primary">GET THE BETA</b-button>
          </b-col>
        </b-row>
      </b-container>
      
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { BImg, BButton, BCard, BCardText } from "bootstrap-vue";

export default {
  name: "Home",
  components: { BImg, BButton, BCard, BCardText },
  methods: {
    ...mapActions("session", ["loadPlayer"]),
    readMore() {
      this.$scrollTo(this.$refs.mainContent.getBoundingClientRect().top);
    },
    gotoTop() {
      this.$scrollTo(0);
    },
    open(url) {
      window.open(url, "_blank");
    }
  },
};
</script>

<style scoped>
#mc_embed_signup {
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
}
.contact-form {
  margin-top: 24px;
}
.contact-form .row {
  margin-top: 12px;
}
.material-icons {
  font-size: 1.4em;
  vertical-align: middle;
}
.description p {
  font-size: 1.1em;
  color: rgb(60, 72, 88);
}
.card {
  cursor: pointer;
}
.card:hover {
  background-color: #1a315c !important;
}
.card h3 {
  padding: 18px 0;
  margin: 0;
  font-size: 18pt;
}
.big-icon {
  font-size: 32pt;
  padding: 0 12px 0px 0;
}
</style>